import { render, staticRenderFns } from "./AdmisionListaPostulanteB.vue?vue&type=template&id=60993bd2"
import script from "./AdmisionListaPostulanteB.vue?vue&type=script&lang=js"
export * from "./AdmisionListaPostulanteB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports